import { noAuthApigateway } from "../intances/apigateway"
import Axios from "axios"

export const getUserHasToChangePassword = async ({ tunnelData, username, bearer }) => {
  const API_URL_GET_USER = `${tunnelData.apiUrl}uaa/api/v1/users/${username}/is-password-reset-required`

  try {
    const headers = {
      Authorization: `Bearer ${bearer}`,
      Accept: "*/*"
    }
    return await Axios.get(API_URL_GET_USER, { headers })
  } catch (error) {
    console.error(error)
    return false
  }
}

export const changePassword = async ({ apiUrl, changePasswordFormValues }) => {
  const API_URL = `middle-business-service/api/v2/users/change-user-token`
  return await noAuthApigateway(apiUrl).post(API_URL, changePasswordFormValues)
}
